import { $ as e, F as t, G as n, L as r, U as i, V as a, _ as o, d as s, f as c, g as l, h as u, i as d, k as f, m as p, nt as m, ot as h, p as g, rt as _, t as v, v as y, w as b } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { n as x, t as S } from "./i18n-lite-BcmwMblk.js";
import { n as C, r as w, t as T } from "./normalize-props-DNjMoRjC.js";
import { t as E } from "./shuffled-D93-rEti.js";
//#region src/webcomponents/image-quiz/locales/de-AT.json
var D = { "image-quiz": {
	multipleInstruction: "Wähle mehrere Antworten aus. ",
	multipleValidity: "Zum Bestätigen wähle mindestens zwei Antworten aus oder überspringe die Frage. ",
	validity: "Zum Bestätigen wähle eine Antwort aus oder überspringe die Frage. "
} }, O = { "image-quiz": {
	multipleInstruction: "Select several answers.",
	multipleValidity: "To validate, select at least two answers. Otherwise, skip.",
	validity: "To validate, select an answer. Otherwise, skip."
} }, k = { "image-quiz": {
	multipleInstruction: "Seleccione varias respuestas.",
	multipleValidity: "Para validar, seleccione al menos dos respuestas. Si no es así, sáltese.",
	validity: "Para confirmar, seleccione una respuesta. De lo contrario, salte."
} }, A = { "image-quiz": {
	multipleInstruction: "Seleccione varias respuestas.",
	multipleValidity: "Para validar, seleccione al menos dos respuestas. Si no es así, sáltese.",
	validity: "Para confirmar, seleccione una respuesta. De lo contrario, salte."
} }, j = {}, M = { "image-quiz": {
	multipleInstruction: "Sélectionnez plusieurs réponses.",
	multipleValidity: "Pour valider, sélectionnez au moins deux réponses. Sinon, passez.",
	validity: "Pour valider, sélectionnez une réponse. Sinon, passez."
} }, N = { "image-quiz": {
	multipleInstruction: "Selezionare diverse risposte.",
	multipleValidity: "Per convalidare, selezionare almeno due risposte. In caso contrario, saltare.",
	validity: "Per confermare, selezionare una risposta. Altrimenti, saltare."
} }, P = { "image-quiz": {
	multipleInstruction: "Selecteer meerdere antwoorden.",
	multipleValidity: "Selecteer ten minste twee antwoorden om te bevestigen. Zo niet, sla dan over.",
	validity: "Selecteer een antwoord om te bevestigen. Sla anders over."
} }, F = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20aria-hidden='true'%20%3e%3cpath%20d='M14%2025.6667C12.3861%2025.6667%2010.8694%2025.3605%209.45%2024.748C8.03055%2024.1355%206.79583%2023.3042%205.74583%2022.2542C4.69583%2021.2042%203.86458%2019.9695%203.25208%2018.55C2.63958%2017.1306%202.33333%2015.6139%202.33333%2014C2.33333%2012.3862%202.63958%2010.8695%203.25208%209.45004C3.86458%208.0306%204.69583%206.79588%205.74583%205.74587C6.79583%204.69587%208.03055%203.86462%209.45%203.25212C10.8694%202.63962%2012.3861%202.33337%2014%202.33337C15.6139%202.33337%2017.1306%202.63962%2018.55%203.25212C19.9694%203.86462%2021.2042%204.69587%2022.2542%205.74587C23.3042%206.79588%2024.1354%208.0306%2024.7479%209.45004C25.3604%2010.8695%2025.6667%2012.3862%2025.6667%2014C25.6667%2015.6139%2025.3604%2017.1306%2024.7479%2018.55C24.1354%2019.9695%2023.3042%2021.2042%2022.2542%2022.2542C21.2042%2023.3042%2019.9694%2024.1355%2018.55%2024.748C17.1306%2025.3605%2015.6139%2025.6667%2014%2025.6667ZM14%2023.3334C16.6056%2023.3334%2018.8125%2022.4292%2020.6208%2020.6209C22.4292%2018.8125%2023.3333%2016.6056%2023.3333%2014C23.3333%2011.3945%2022.4292%209.18754%2020.6208%207.37921C18.8125%205.57087%2016.6056%204.66671%2014%204.66671C11.3944%204.66671%209.1875%205.57087%207.37916%207.37921C5.57083%209.18754%204.66666%2011.3945%204.66666%2014C4.66666%2016.6056%205.57083%2018.8125%207.37916%2020.6209C9.1875%2022.4292%2011.3944%2023.3334%2014%2023.3334Z'%20fill='%23C8CFD9'/%3e%3c/svg%3e", I = "data:image/svg+xml,%3csvg%20width='28'%20height='28'%20viewBox='0%200%2028%2028'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20aria-hidden='true'%20%3e%3cpath%20d='M12.3457%2015.8559L10.0187%2013.5289C9.77706%2013.2871%209.47226%2013.1661%209.10437%2013.1661C8.73668%2013.1661%208.43189%2013.2871%208.19%2013.5289C7.9483%2013.7706%207.82862%2014.0754%207.83096%2014.4433C7.83329%2014.811%207.95531%2015.1157%208.197%2015.3574L11.4106%2018.571C11.6781%2018.8368%2011.9903%2018.9697%2012.3471%2018.9697C12.7037%2018.9697%2013.015%2018.8368%2013.281%2018.571L19.768%2012.0837C20.0099%2011.842%2020.1308%2011.5385%2020.1308%2011.1732C20.1308%2010.8076%2020.0099%2010.504%2019.768%2010.2623C19.5263%2010.0204%2019.2215%209.89944%2018.8536%209.89944C18.4859%209.89944%2018.1812%2010.0204%2017.9395%2010.2623L12.3457%2015.8559ZM14%2025.9038C12.349%2025.9038%2010.7998%2025.5915%209.35258%2024.9669C7.90514%2024.3424%206.64611%2023.4949%205.5755%2022.4245C4.50508%2021.3539%203.6576%2020.0948%203.03304%2018.6474C2.40848%2017.2002%202.09621%2015.651%202.09621%2014C2.09621%2012.349%202.40848%2010.7998%203.03304%209.35257C3.6576%207.90512%204.50508%206.64609%205.5755%205.57548C6.64611%204.50507%207.90514%203.65758%209.35258%203.03302C10.7998%202.40847%2012.349%202.09619%2014%202.09619C15.651%202.09619%2017.2002%202.40847%2018.6474%203.03302C20.0949%203.65758%2021.3539%204.50507%2022.4245%205.57548C23.4949%206.64609%2024.3424%207.90512%2024.967%209.35257C25.5915%2010.7998%2025.9038%2012.349%2025.9038%2014C25.9038%2015.651%2025.5915%2017.2002%2024.967%2018.6474C24.3424%2020.0948%2023.4949%2021.3539%2022.4245%2022.4245C21.3539%2023.4949%2020.0949%2024.3424%2018.6474%2024.9669C17.2002%2025.5915%2015.651%2025.9038%2014%2025.9038Z'%20fill='%233D68FF'/%3e%3c/svg%3e", L = [
	"aria-labelledby",
	"aria-selected",
	"readonly",
	"aria-readonly",
	"tabindex"
], R = ["src"], z = { key: 0 }, B = ["id"], V = ["id"], H = /*#__PURE__*/ v(/* @__PURE__ */ b({
	__name: "ImageOption.ce",
	props: {
		choice: { type: Object },
		maxChoicesPerLine: { type: Number },
		imageClass: { type: String },
		nameClass: { type: String },
		selected: { type: Boolean },
		tabFocusable: { type: Boolean },
		readonly: { type: Boolean }
	},
	emits: [
		"toggle",
		"next",
		"previous"
	],
	setup(n, { expose: r }) {
		let i = n, o = e(), l = p(() => i.selected ? I : F);
		function d() {
			o.value.focus();
		}
		r({ focus: d });
		let g = a();
		return (e, r) => (t(), y("div", {
			ref_key: "el",
			ref: o,
			role: "option",
			class: _(["image-option", `image-option--max${i.maxChoicesPerLine}`]),
			"aria-labelledby": m(g),
			"aria-selected": n.selected,
			readonly: n.readonly,
			"aria-readonly": n.readonly,
			tabindex: n.tabFocusable ? 0 : -1,
			onClick: r[0] ||= c((t) => e.$emit("toggle"), ["stop"]),
			onKeydown: [
				r[1] ||= s(c((t) => e.$emit("toggle"), ["stop", "prevent"]), ["space"]),
				r[2] ||= s(c((t) => e.$emit("previous"), ["stop", "prevent"]), ["up", "left"]),
				r[3] ||= s(c((t) => e.$emit("next"), ["stop", "prevent"]), ["down", "right"])
			]
		}, [u("img", {
			class: "state-icon",
			src: l.value,
			alt: ""
		}, null, 8, R), n.choice.image ? (t(), y("figure", z, [u("img", f(n.choice.image, {
			class: n.imageClass,
			alt: ""
		}), null, 16), u("figcaption", {
			id: m(g),
			class: _(n.nameClass)
		}, h(n.choice.name), 11, B)])) : (t(), y("span", {
			key: 1,
			id: m(g)
		}, h(n.choice.name), 9, V))], 42, L));
	}
}), [["styles", [".image-option{background:#fff;border:2px solid #c1c7d0;border-radius:12px;flex-direction:column;justify-content:center;align-items:center;width:calc(20% - 2em);min-width:150px;margin:.5rem;padding:1rem;display:flex;position:relative}.image-option--max4{width:calc(25% - 2em);min-width:175px}.image-option--max3{width:calc(33% - 2em)}.image-option--max2{width:calc(50% - 2em);min-width:300px}.image-option--max1{width:calc(100% - 4em);min-width:300px}.image-option:hover{cursor:pointer;transition:transform .1s ease-in;transform:scale(1.04);box-shadow:0 3px 10px #0000001a}.image-option:focus{border-color:#0000;outline:none}.image-option:focus:before{content:\"\";z-index:4;border:4px solid #2c75ff;border-radius:12px;width:100%;height:100%;position:absolute}.image-option[aria-selected=true]{border-color:#0000}.image-option[aria-selected=true]:after{content:\"\";z-index:3;background:#3d68ff4d;border:3px solid #72a3ff;border-radius:12px;width:100%;height:100%;position:absolute}.image-option .state-icon{position:absolute;top:6px;right:6px}.image-option figure{text-align:center;flex-direction:column;justify-content:center;align-items:center;width:100%;height:100%;margin:0;display:flex}.image-option figure img{max-width:100%;height:auto}.image-option figure img.icon{width:auto;max-height:100px}.image-option figure img.medium{max-width:50%;height:auto}.image-option figure figcaption{margin:1ex}"]]]), U = { class: "image-quiz-container" }, W = ["id", "innerHTML"], G = ["id"], K = [
	"aria-multiselectable",
	"aria-labelledby",
	"aria-describedby"
], q = /*#__PURE__*/ v(/* @__PURE__ */ b({
	__name: "ImageQuiz.ce",
	props: {
		multiple: {
			type: Boolean,
			default: !1
		},
		choices: { type: Array },
		maxChoicesPerLine: {
			default: 5,
			type: Number
		},
		name: { type: String },
		hideChoicesName: { type: Boolean },
		orderChoices: { type: Boolean },
		imageChoicesSize: {
			default: "icon",
			type: String
		},
		showName: {
			type: Boolean,
			default: !1
		},
		context: { type: String },
		readonly: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["answer"],
	setup(s, { emit: c }) {
		let d = c, f = p(() => s.hideChoicesName ? "sr-only" : ""), v = p(() => s.orderChoices ? s.choices : E(s.choices)), b = p(() => s.multiple && s.context !== "pix-junior"), S = e(Array(s.choices.length).fill(!1)), C = p(() => v.value.filter((e, t) => S.value[t])), { t: w } = x(), T = p(() => {
			if (s.multiple) return C.value.length < 2 ? {
				answer: "",
				validity: w("image-quiz.multipleValidity")
			} : {
				answer: C.value.map((e) => e.response ?? e.name).sort().join(","),
				validity: ""
			};
			let e = C.value[0];
			return e ? {
				answer: e?.response ?? e?.name ?? "",
				validity: ""
			} : {
				answer: "",
				validity: w("image-quiz.validity")
			};
		}), D = a();
		n(() => {
			d("answer", T.value);
		});
		let O = p(() => {
			let e = S.value.indexOf(!0);
			return e === -1 ? 0 : e;
		}), k = i("options");
		function A(e) {
			s.readonly || (s.multiple || S.value.fill(!1), S.value[e] = !S.value[e]);
		}
		function j(e) {
			e = (e + s.choices.length) % s.choices.length, s.multiple || A(e), k.value[e].focus();
		}
		return (e, n) => (t(), y("div", U, [
			u("label", {
				id: m(D),
				class: _(["image-quiz-label", { "sr-only": !s.showName }]),
				innerHTML: s.name
			}, null, 10, W),
			b.value ? (t(), y("p", {
				key: 0,
				id: `${m(D)}-instruction`,
				class: "image-quiz-multiple-instruction"
			}, h(e.$t("image-quiz.multipleInstruction")), 9, G)) : o("", !0),
			u("div", {
				role: "listbox",
				class: "image-quiz",
				"aria-multiselectable": s.multiple,
				"aria-labelledby": m(D),
				"aria-orientation": "horizontal",
				"aria-describedby": `${m(D)}-instruction`
			}, [(t(!0), y(g, null, r(v.value, (e, n) => (t(), l(H, {
				ref_for: !0,
				ref_key: "options",
				ref: k,
				key: n,
				choice: e,
				"max-choices-per-line": s.maxChoicesPerLine,
				"name-class": f.value,
				"image-class": s.imageChoicesSize,
				selected: S.value[n],
				readonly: s.readonly,
				"tab-focusable": n === O.value,
				onToggle: (e) => A(n),
				onNext: (e) => j(n + 1),
				onPrevious: (e) => j(n - 1)
			}, null, 8, [
				"choice",
				"max-choices-per-line",
				"name-class",
				"image-class",
				"selected",
				"readonly",
				"tab-focusable",
				"onToggle",
				"onNext",
				"onPrevious"
			]))), 128))], 8, K)
		]));
	}
}), [["styles", ["*{box-sizing:border-box}.image-quiz-label{margin:1rem 0;font-size:1.25rem;display:inline-block}.image-quiz-multiple-instruction{margin:0 16px 5px;font-size:14px}.image-quiz-container{padding:10px 0}.image-quiz{flex-wrap:wrap;justify-content:space-around;display:flex}.sr-only{clip-path:inset(50%);border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}"]]]);
//#endregion
//#region src/webcomponents/image-quiz/image-quiz.ce.js
S.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": D,
	"./locales/en.json": O,
	"./locales/es-419.json": k,
	"./locales/es.json": A,
	"./locales/fr-BE.json": j,
	"./locales/fr.json": M,
	"./locales/it.json": N,
	"./locales/nl.json": P
}));
function J(e) {
	return {
		...e,
		maxChoicesPerLine: T(e.maxChoicesPerLine),
		imageChoicesSize: w(e.imageChoicesSize),
		context: w(e.context),
		choices: e.choices.map((e) => ({
			...e,
			image: C(e.image),
			response: w(e.response)
		}))
	};
}
var Y = d(q, { configureApp(e) {
	S.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(S);
} });
Y.prototype.normalizeProps = J, window.customElements.define("image-quiz", Y);
var X = d(q, { configureApp(e) {
	S.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(S);
} });
X.prototype.normalizeProps = J, window.customElements.define("qcu-image", X);
//#endregion
export { M as a, k as c, N as i, O as l, q as n, j as o, P as r, A as s, J as t, D as u };
